import React from 'react';
interface ProgressBarProps {
  current: number;
  total: number;
}
export function ProgressBar({
  current,
  total
}: ProgressBarProps) {
  const percentage = current / total * 100;
  return <div className="w-full" data-id="element-119">
      <div className="flex justify-between items-center mb-2" data-id="element-120">
        <span className="text-sm text-crown-body" data-id="element-121">
          Question {current} of {total}
        </span>
        <span className="text-sm text-crown-body" data-id="element-122">
          {Math.round(percentage)}%
        </span>
      </div>
      <div className="w-full h-2 bg-crown-surface rounded-full overflow-hidden" data-id="element-123">
        <div className="h-full bg-crown-red transition-all duration-300 ease-out" style={{
        width: `${percentage}%`
      }} role="progressbar" aria-valuenow={percentage} aria-valuemin={0} aria-valuemax={100} data-id="element-124" />
      </div>
    </div>;
}